import { render, staticRenderFns } from "./applicationmaterials.vue?vue&type=template&id=494f1ee6&scoped=true&"
import script from "./applicationmaterials.vue?vue&type=script&lang=js&"
export * from "./applicationmaterials.vue?vue&type=script&lang=js&"
import style0 from "./applicationmaterials.vue?vue&type=style&index=0&id=494f1ee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f1ee6",
  null
  
)

export default component.exports